import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Layout } from '@/components/layout';
import { ResetPasswordForm } from '@/components/auth';
import { Card } from '@/components/ui';

export function ResetPasswordPage() {
  const navigate = useNavigate();

  // Set document title
  useEffect(() => {
    document.title = 'Reset Password - BiteWise Healthcare Platform';
  }, []);

  const handleResetSuccess = () => {
    // Stay on the same page to show success message
    // The form component handles the success state internally
  };

  const handleBackToLogin = () => {
    navigate('/login', { replace: true });
  };

  return (
    <Layout showHeader={true}>
      <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          {/* Auth Form */}
          <Card className="p-8">
            <ResetPasswordForm
              onSuccess={handleResetSuccess}
              onBackToLogin={handleBackToLogin}
            />
          </Card>

        </div>
      </div>
    </Layout>
  );
}